var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSupportDark(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.33366 13C8.33366 12.2636 7.73671 11.6666 7.00033 11.6666C6.26395 11.6666 5.66699 12.2636 5.66699 13C5.66699 13.7363 6.26395 14.3333 7.00033 14.3333C7.73671 14.3333 8.33366 13.7363 8.33366 13Z",
    fill: "#03B449"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6663 5.66663C11.6663 3.45749 9.57701 1.66663 6.99967 1.66663C4.42235 1.66663 2.33301 3.45749 2.33301 5.66663",
    stroke: "#03B449",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.33301 12.9999H8.99967C10.4724 12.9999 11.6663 11.806 11.6663 10.3333",
    stroke: "#03B449",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1 6.99996C1 6.26358 1.59695 5.66663 2.33333 5.66663H4V10.3333H2.33333C1.59695 10.3333 1 9.73636 1 8.99996V6.99996Z",
    fill: "#03B449",
    stroke: "#03B449",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13 6.99996C13 6.26358 12.4031 5.66663 11.6667 5.66663H10V10.3333H11.6667C12.4031 10.3333 13 9.73636 13 8.99996V6.99996Z",
    fill: "#03B449",
    stroke: "#03B449",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportDark);
export default __webpack_public_path__ + "static/media/supportDark.717a3ef407a3afdca53a153eedb7f769.svg";
export { ForwardRef as ReactComponent };